<!--
 * @Description: 医生端登录
 * @Date: 2019-10-24 10:58:17
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 15:22:27
 * 1:主任医师;2:副主任医师;3:主治医师;4:住院医师;5:助理医师
 -->
<template>
  <div class="SubmitReview">
    <v-card class="mx-auto box" max-width="344">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">基本信息</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">执业点信息</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3">执照信息</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4">提交审核</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="5">审核状态</v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>
        <v-stepper-items>
          <!-- 基本信息 -->
          <v-stepper-content step="1">
            <v-card class="mb-12" color="green lighten-5" height="600px">
              <v-card-title>1. 请填写以下基本信息</v-card-title>
              <v-card-subtitle>
                <span class="text__"></span> 请务必填写真实有效的信息
              </v-card-subtitle>
              <v-col cols="12" sm="6" md="6" class="mx-auto">
                <v-text-field label="真实姓名" v-model="datas.name" outlined color="black"></v-text-field>
              </v-col>
              <v-col class="d-flex mx-auto" cols="12" sm="6" md="6">
                <v-select :items="items" v-model="datas.level" label="您的职称" outlined color="black"></v-select>
              </v-col>
              <v-col class="mx-auto" cols="12" sm="6" md="6">
                <v-textarea
                  outlined
                  name="input-7-4"
                  label="您擅长的领域(疾病)"
                  value
                  :no-resize="true"
                  color="black"
                  v-model="datas.speciality"
                ></v-textarea>
              </v-col>
              <v-col class="mx-auto" cols="12" sm="6" md="6">
                <v-textarea
                  outlined
                  name="input-7-4"
                  label="您的个人简介(行医经验,学术、执业经历等)"
                  value
                  :no-resize="true"
                  color="black"
                  v-model="datas.intro.post_title"
                ></v-textarea>
              </v-col>
            </v-card>
            <v-col class="text-right" cols="12" sm="12">
              <!-- <v-btn text style="margin-right: 20px;" @click="hosp_list">返回上级</v-btn> -->
              <v-btn color="indigo darken-1 white--text" @click="basicInformation">下一步</v-btn>
            </v-col>
          </v-stepper-content>
          <!-- 执业点 -->
          <v-stepper-content step="2">
            <v-card class="mb-12" color="light-green lighten-5" height="600px">
              <v-card-title>2. 请搜索/选择执业点</v-card-title>
              <v-col cols="12" sm="6" md="6" class="mx-auto">
                <v-text-field
                  label="搜索执业点"
                  v-model="datas.workplaces[0].name"
                  outlined
                  color="black"
                  @input="oneList__();"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="mx-auto">
                <!-- <v-flex xs12 sm3 > -->
                <v-select
                  :items="Object.keys( this.workplaces )"
                  v-model="sheng"
                  :rules="[() => !!sheng || '请选择您所在的省份',() => !!sheng && sheng.length >= 1 || '请选择您所在的省份（如：广东省）',]"
                  @input="shi = workplaces[ sheng ][0];oneList_( hospList );"
                  label="* 省份"
                  outlined
                  color="black"
                ></v-select>
                <!-- </v-flex>
                <v-flex xs12 sm3 >-->
                <v-select
                  :items="this.workplaces[sheng]"
                  v-model="shi"
                  :disabled="sheng == ''"
                  :rules="[() => !!shi || '请选择您所在的城市',() => !!shi && shi.length >= 1 || '请选择您所在的城市（如：深圳市）',]"
                  label="* 城市"
                  outlined
                  color="black"
                  @change="oneList_( hospList );"
                ></v-select>
                <!-- </v-flex> -->
                <v-col cols="12" sm="12" md="12" class="mx-auto box_list">
                  <v-card class="mx-auto" tile>
                    <!-- <v-list :disabled="true" v-for="(item, index) in oneList" :key="index">
                      <v-list-item two-line  >
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <v-list-item-subtitle>{{sheng}}-{{shi }}, {{ item.ress }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                        :dense="dense"
                        :two-line="twoLine"
                        :three-line="threeLine"
                        :shaped="shaped"
                        :flat="flat"
                        :subheader="subheader"
                        :inactive="inactive"
                        :sub-group="subGroup"
                        :nav="nav"
                        :avatar="avatar"
                        :rounded="rounded"
                    -->
                    <v-list :disabled="false">
                      <v-subheader v-if="oneList.length !== 0">执业点列表</v-subheader>
                      <v-subheader v-if="oneList.length == 0">该地区未找到执业点，请在搜索框添加您的执业点</v-subheader>
                      <v-subheader v-if="oneList.length == 0">
                        将【 {{ datas.workplaces[0].name }} 】设为您的执业点？
                        <v-btn text color="indigo darken-1 white--text" @click="e1 = 3">确定</v-btn>
                      </v-subheader>
                      <v-list-item-group color="primary">
                        <v-list-item
                          v-for="(item, index) in oneList"
                          :key="index"
                          @click="point( item.name )"
                        >
                          <v-list-item-content>
                            <v-list-item-title v-html="item.name"></v-list-item-title>
                            <v-list-item-subtitle v-html="item.ress"></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-col>
              </v-col>
            </v-card>
            <v-col class="text-right" cols="12" sm="12">
              <v-btn text style="margin-right: 20px;" @click="e1 = 1">返回上级</v-btn>
              <v-btn color="indigo darken-1 white--text" @click="practicePoint">下一步</v-btn>
            </v-col>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card class="mb-12" color="green lighten-5" height="600px">
              <v-card-title>3. 以下信息仅供认证使用，不会公开</v-card-title>
              <v-card-subtitle></v-card-subtitle>
              <v-card-subtitle></v-card-subtitle>
              <v-card-subtitle>医师执业证书（上传带有职业地点详情页的图片）</v-card-subtitle>
              <v-col cols="12" sm="6" md="6" class="mx-auto">
                <v-file-input
                  v-model="License_files"
                  color="deep-purple accent-4"
                  label="选择医师执业证书"
                  placeholder
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="License_input"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >{{ text }}</v-chip>
                    <span
                      v-else-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                    >+{{ License_files.length - 2 }} File(s)</span>
                  </template>
                </v-file-input>
              </v-col>

              <v-card-subtitle>职称证书或工作证（上传包含职称证明信息的证件）</v-card-subtitle>
              <v-col cols="12" sm="6" md="6" class="mx-auto">
                <v-file-input
                  v-model="Work_files"
                  color="deep-purple accent-4"
                  label="职称证书或工作证"
                  placeholder
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="Work_input"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >{{ text }}</v-chip>
                    <span
                      v-else-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                    >+{{ Work_files.length - 2 }} File(s)</span>
                  </template>
                </v-file-input>
              </v-col>
            </v-card>
            <v-col class="text-right" cols="12" sm="12">
              <v-btn text style="margin-right: 20px;" @click="e1 = 2">返回上级</v-btn>
              <v-btn color="indigo darken-1 white--text" @click="upData">下一步</v-btn>
            </v-col>
          </v-stepper-content>
          <v-stepper-content step="4">
            <v-card class="mb-12" color="deep-orange lighten-5 info_" height="600px">
              <v-card class="mb-12" tile style="margin-bottom: 0 !important;">
                <v-card-title>4. 请您确认以下信息</v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>真实姓名</v-list-item-subtitle>
                    <v-list-item-title>{{ datas.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>职称</v-list-item-subtitle>
                    <v-list-item-title v-if="datas.level == 1">主任医师</v-list-item-title>
                    <v-list-item-title v-else-if="datas.level == 2">副主任医师</v-list-item-title>
                    <v-list-item-title v-else-if="datas.level == 3">主治医师</v-list-item-title>
                    <v-list-item-title v-else-if="datas.level == 4">住院医师</v-list-item-title>
                    <v-list-item-title v-else-if="datas.level == 5">助理医师</v-list-item-title>
                    <!-- 1:主任医师;2:副主任医师;3:主治医师;4:住院医师;5:助理医师 -->
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>您的执业点</v-list-item-subtitle>
                    <v-list-item-title>{{ sheng }}-{{ shi }} {{ datas.workplaces[0].name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>您擅长的领域（疾病）</v-list-item-subtitle>
                    <v-list-item-title>{{ datas.speciality }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>您的个人简介(行医经验，学术、执业经历等)</v-list-item-subtitle>
                    <v-list-item-title>{{ datas.intro.post_title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>医师执业证书</v-list-item-subtitle>
                    <v-list-item-title>
                      <v-row align="center" justify="center" >
                        <v-img
                          :src="License_64"
                          lazy-src="https://picsum.photos/id/11/10/6"
                          aspect-ratio="1"
                          class="grey lighten-2"
                          max-height="300"
                          min-height="300"
                          @click="bigImage( License_64 )" 
                        ></v-img>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>职称证书或工作证</v-list-item-subtitle>
                    <v-list-item-title>
                      <v-row align="center" justify="center" >
                        <v-img
                          :src="Work_64"
                          lazy-src="https://picsum.photos/id/11/10/6"
                          aspect-ratio="1"
                          class="grey lighten-2"
                          max-height="300"
                          min-height="300"
                          @click="bigImage( Work_64 )"
                        ></v-img>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-card>
            <v-col class="text-right" cols="12" sm="12">
              <v-btn text style="margin-right: 20px;" @click="e1 = 3">返回上级</v-btn>
              <v-btn color="indigo darken-1 white--text" @click="submt">提交审核</v-btn>
            </v-col>
          </v-stepper-content>
          <v-stepper-content step="5">
            <v-card class="mb-12" color="orange lighten-5 info_" height="600px">
              <v-card-title>5. 身份审核状态</v-card-title>
              <v-card-subtitle>您的资料已提交成功！我们将会在3个工作日之内返回审核结果，请随时留意此页信息。</v-card-subtitle>
              <div class="ent_" v-if="!success">
                <p class="ent_p0">
                  <v-icon>sentiment_satisfied_alt</v-icon>
                </p>
                <p class="ent_p1">已提交，待审核</p>
                <p class="ent_p2">{{ time | time }}</p>
                <p class="ent_p3">
                  提交的信息有误？您可以选择
                  <v-btn text class="indigo--text" @click="e1 = 1">重新填写</v-btn>
                </p>
                <p class="ent_p4">
                  客服热线：
                  <span class="indigo--text">0755-33158961</span>
                </p>
              </div>
              <div class="ent_" v-if="success">
                <p class="ent_p0_">
                  <v-icon>sentiment_dissatisfied</v-icon>
                </p>
                <p class="ent_p1">请重新上传审核材料</p>
                <p class="ent_p2">{{ time | time }}</p>
                <p class="ent_p2_" style="margin-top: 30px;">医生您好，未通过审核的原因可能是：</p>
                <p v-if="successText !== ''" class="pink--text" style="padding: 10px 50px;" > {{ successText }} </p>
                <p class="ent_p2_ blue-grey--text" v-if="successText == ''">1. 未按要求填写个人信息</p>
                <p class="ent_p2_ blue-grey--text" v-if="successText == ''">2. 未按要求上传个人证件</p>
                <p class="ent_p2_ blue-grey--text" v-if="successText == ''">3. 所填写的信息与上传的证件不一致（如执业证、职称等）</p>
                <p class="ent_p3_">
                  提交的信息有误？您可以选择
                  <v-btn text class="indigo--text" @click="e1 = 1">重新填写</v-btn>
                </p>
                <p class="ent_p4">
                  客服热线：
                  <span class="indigo--text">0755-33158961</span>
                </p>
              </div>
            </v-card>
            <v-col class="text-right" cols="12" sm="12">
              <!-- <v-btn text style="margin-right: 20px;">返回</v-btn>
              <v-btn color="indigo darken-1 white--text" @click="e1 = 1">下一步</v-btn> -->
            </v-col>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <Image_ ref="Image_"></Image_>
  </div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import { mask } from "vue-the-mask";
import Location from "../serves/location.js";
import Image_ from '../components/home/image.vue';
export default {
  name: "SubmitReview",
  directives: {
    mask
  },
  components: {
    // HelloWorld
    Image_
  },
  data: () => ({
    e1: 1,
    // 1:主任医师;2:副主任医师;3:主治医师;4:住院医师;5:助理医师
    items: [
      { text: "助理医师", value: 5 },
      { text: "住院医师", value: 4 },
      { text: "主治医师", value: 3 },
      { text: "副主任医师", value: 2 },
      { text: "主任医师", value: 1 }
    ],
    /* 省市json */
    workplaces: Location.location,
    sheng: "广东省",
    shi: "深圳市",
    License_files: null,
    License_64: "",
    Work_files: null,
    Work_64: "",

    success: false,
    successText: '',
    time: 0,
    datas: {
      name: "",
      level: 4,
      speciality: "",
      workplaces: [
        { area: "", name: "", index: 1 }
      ],
      intro: {
        post_title: "",
        work_experience: "",
        academic_experience: ""
      }
    },
    // 执业点列表
    hospList: [],
    oneList: []
  }),
  /*
  datas: {
    "name":"汲英豪",
    "level":4,
    "speciality":"擅长的疾病",
    "workplaces":[{"area":"广东省,深圳市","name":"123亿元","index":1}],
    "intro":{"post_title":"行医经验","work_experience":"","academic_experience":""}
    }
    certified_files: (binary)
    authentication_files: (binary)
  */
  mounted() {
    this.hosp_list();
    window.console.log( this.$route.query.pass_validation )
    if( this.$route.query.pass_validation !== undefined ){
      if( this.$route.query.pass_validation == 2 ){
        this.e1 = 5;
        this.success = this.$route.query.switch,
        this.time = this.$route.query.time
      }
      if(this.$route.query.pass_validation == 3){
        this.e1 = 5;
        this.success = this.$route.query.switch,
        this.successText = this.$route.query.rejection_reason,
        this.time = this.$route.query.time
      }
    }

  },
  methods: {
    /* 大图预览 */
    bigImage( img ){
      window.console.log( this.$refs.Image_ )
      this.$refs.Image_.info(true, img);
      
    }, 
    /* 验证基本信息 */
    basicInformation() {
      if (this.datas.name.length < 1) {
        return this.$Dialog.getProductCheckResult_({
          text: `请输入您的真实姓名（2-5个汉字）`,
          timeout: 3000,
          snackbar: true
        });
      }
      if (this.datas.speciality.length < 9) {
        return this.$Dialog.getProductCheckResult_({
          text: `请输入您擅长的疾病（10-2000个汉字）`,
          timeout: 3000,
          snackbar: true
        });
      }
      if (this.datas.intro.post_title.length < 9) {
        return this.$Dialog.getProductCheckResult_({
          text: `请输入您的个人简介(行医经验,学术、执业经历等)（10-2000个汉字）`,
          timeout: 3000,
          snackbar: true
        });
      }
      this.e1 = 2;
    },
    /* 验证执业点信息 */
    practicePoint() {
      if (this.datas.workplaces[0].name == "") {
        return this.$Dialog.getProductCheckResult_({
          text: `请搜索或选择您的执业点`,
          timeout: 3000,
          snackbar: true
        });
      }
      this.e1 = 3;
    },
    /* 验证执照信息 */

    upData() {
      if (this.License_files == null) {
        return this.$Dialog.getProductCheckResult_({
          text: `请选择医师职业证书（上传带有职业地点详情页的图片）`,
          timeout: 3000,
          snackbar: true
        });
      }
      if (this.Work_files == null) {
        return this.$Dialog.getProductCheckResult_({
          text: `职称证书或工作证（上传包含职称证明信息的证件）`,
          timeout: 3000,
          snackbar: true
        });
      }
      this.e1 = 4;
    },
    /* 通过搜索选择执业点 */

    point(name) {
      this.datas.workplaces[0].name = name;
      this.e1 = 3;
    },
    /* 提交审核 */
    submt() {
      // doctor_authentication
      window.console.log(this.License_files);
      let formData = new FormData();
      formData.append("datas", JSON.stringify(this.datas));
      formData.append("certified_files", this.License_files);
      formData.append("authentication_files", this.Work_files);
      this.$axios({
        method: "put",
        url: this.$apis.URL.doctor_authentication,
        data: formData
      })
        .then(req => {
          if (req.data.result == 0) {
            this.$Dialog.getProductCheckResult_({
              text: `提交成功！`,
              timeout: 3000,
              snackbar: true
            });
            this.e1 = 5;
            this.success = false;
          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    },
    hosp_list() {
      // api/v1/doctor/hosp_list
      this.$axios({
        method: "get",
        url: `${this.$apis.URL.doctor_hosp_list}`,
        data: {}
      })
        .then(req => {
          window.console.log( req.data )
          if (req.data.result == 0) {
            // this.$Dialog.getProductCheckResult_({
            //   text: `获取执业点列表成功！`,
            //   timeout: 3000,
            //   snackbar: true
            // });
            this.hospList = req.data.datas;
            this.oneList_(this.hospList);
            // window.console.log(this.oneList);
          } else {
            window.console.log( req.data )
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
          window.console.log( error )
          if (error.data.result == 1002) {
              window.history.back(-1);
          }
        });
    },
    // 筛选搜索或选择的结果
    oneList_(A) {
      window.console.log(A);
      if (this.hospList.length > 0) {
        this.oneList = [];
        A.forEach(element => {
          if (element.province == this.sheng) {
            element.cities.forEach(item => {
              if (item.city == this.shi) {
                item.hosp.forEach(im => {
                  this.oneList.push({
                    name: im.name,
                    ress: im.address
                  });
                });
              }
            });
          }
        });
      }
    },
    //  筛选框触发
    oneList__() {
      if (this.datas.workplaces[0].name !== "") {
        this.oneList = [];
        this.hospList.forEach(element => {
          element.cities.forEach(item => {
            item.hosp.forEach(im => {
              if (im.name.indexOf(`${this.datas.workplaces[0].name}`) !== -1) {
                this.oneList.push({
                  name: im.name,
                  ress: im.address
                });
              }
            });
          });
        });
      } else {
        this.oneList_(this.hospList);
      }
    },
    License_input() {
      if (this.License_files) {
        let url;
        var agent = navigator.userAgent; //检测浏览器版本
        if (agent.indexOf("MSIE") >= 1) {
          url = this.License_files.value;
        } else if (agent.indexOf("Firefox") > 0) {
          url = window.URL.createObjectURL(this.License_files);
        } else if (agent.indexOf("Chrome") > 0) {
          url = window.URL.createObjectURL(this.License_files);
        }
        this.License_64 = url;
      }
    },
    Work_input() {
      if (this.Work_files) {
        let url;
        var agent = navigator.userAgent; //检测浏览器版本
        if (agent.indexOf("MSIE") >= 1) {
          url = this.Work_files.value;
        } else if (agent.indexOf("Firefox") > 0) {
          url = window.URL.createObjectURL(this.Work_files);
        } else if (agent.indexOf("Chrome") > 0) {
          url = window.URL.createObjectURL(this.Work_files);
        }
        this.Work_64 = url;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.SubmitReview {
  width: 100%;
  height: 100%;
  .box {
    width: 1150px;
    min-width: 880px;
    max-width: 1150px;
    // height: 100%;
  }
  .box_list {
    height: 240px;
    overflow-y: auto;
    padding: 0;
    > div {
      margin: 0;
    }
  }
  .box_list::-webkit-scrollbar {
    width: 0;
  }
  .col-sm-6 {
    padding: 0;
  }
  .text__ {
    display: inline-block;
    width: 20px;
  }
  .info_ {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .ent_ {
    > p {
      text-align: center;
    }
    .ent_p0 {
      > i {
        font-size: 80px;
        margin-top: 100px;
      }
    }
    .ent_p0_ {
      > i {
        font-size: 80px;
        margin-top: 50px;
      }
    }
    .ent_p1 {
      font-size: 30px;
      margin-bottom: 5px;
    }
    .ent_p2 {
      margin-top: 5px;
    }
    .ent_p2_ {
      margin: 5px;
      text-align: left;
      margin-left: 30%;
    }
    .ent_p3 {
      margin-bottom: 5px;
      margin-top: 100px;
    }
    .ent_p3_ {
      margin-bottom: 5px;
      margin-top: 30px;
    }
    .ent_p4 {
      margin-top: 5px;
    }
  }
}
</style>


